<template>
    <div class="centered-container">
        <h1>Not found</h1>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>